import { render } from "./ModuleAssessment.vue?vue&type=template&id=13832289&scoped=true"
import script from "./ModuleAssessment.vue?vue&type=script&lang=js"
export * from "./ModuleAssessment.vue?vue&type=script&lang=js"

import "./ModuleAssessment.vue?vue&type=style&index=0&id=13832289&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13832289"]])

export default __exports__